import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router';
import { NotFoundResult } from 'components';
import { routes } from 'routes';
import { BrowserRouter } from 'react-router-dom';

const RestrictedRoute = () => {
  return (
    <Suspense fallback={NotFoundResult}>
      <BrowserRouter>
        <Switch>
          {routes.public.map((route, i) => (
            <Route
              key={i}
              path={route.path}
              component={route.component}
              exact
            />
          ))}
          <Route path='*' component={NotFoundResult} />
        </Switch>
      </BrowserRouter>
    </Suspense>
  );
};

export default RestrictedRoute;
